import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { fonts } from "../theme";

export default function Logo({ color = "#0d6efd", size = 24, subtitle = true, cardShadow = false }) {
  const content = (
    <div className="d-inline-flex align-items-center gap-2 text-decoration-none">
      <ShieldCheck size={size} color={color} strokeWidth={2.4} className="flex-shrink-0" />
      <div style={{ lineHeight: 1.1, textAlign: "left" }}>
        <div style={{
          fontFamily: fonts.display, fontWeight: 800, fontSize: size, letterSpacing: 1,
          color, whiteSpace: "nowrap"
        }}>
          WIBIL
        </div>
        {subtitle && (
          <div style={{ fontFamily: fonts.mono, fontSize: Math.max(8, size * 0.32), letterSpacing: 0.5, color, opacity: 0.85, whiteSpace: "nowrap" }}>
            WORKFORCE INFORMATION BUREAU
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Link
      to="/"
      style={{
        display: "inline-flex",
        alignItems: "center",
        textDecoration: "none",
        cursor: "pointer",
        color: "inherit"
      }}
    >
      {cardShadow ? (
        <div className="card shadow-sm border rounded-4 px-3 py-2 bg-body-tertiary d-inline-flex align-items-center">
          {content}
        </div>
      ) : (
        content
      )}
    </Link>
  );
}
